import { Table } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getCRSRiskScoreHistory } from '../../../../redux/actions/crs/crsRiskDetail';
import { CRS_CONSTANTS } from '../../../constants/crsContants';
import styles from './index.scss';

const { GET_DATA } = CRS_CONSTANTS;

const columns = [
  {
    title: 'Change',
    width: 90,
    dataIndex: 'change'
  },
  {
    title: 'Reasons',
    dataIndex: 'reason',
    width: 250
  },
  {
    title: 'Date & Time',
    dataIndex: 'updatedTimestamp',
    render: (t) => <>{moment(t).format('DD/MM/YYYY[T]HH:mm:ss.SSS[Z]')}</>
  },
  {
    title: 'Changed By',
    dataIndex: 'changedBy'
  }
];

export const ScoreHistoryTable = ({
  customerKey,
  scoreHistory,
  total,
  isFetching,
  dispatch
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchData = (page, pageSize) => {
    dispatch(
      getCRSRiskScoreHistory(
        { customerKey, limit: pageSize, offset: page * pageSize },
        GET_DATA
      )
    );
  };

  const onPaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
    fetchData(page - 1, pageSize);
  };

  useEffect(() => {
    fetchData(currentPage - 1, pageSize);
  }, []);

  return (
    <Table
      className={styles.table}
      dataSource={scoreHistory}
      rowKey="updatedTimestamp"
      columns={columns}
      loading={isFetching}
      pagination={{
        total,
        current: currentPage,
        pageSize,
        onChange: onPaginationChange,
        showSizeChanger: false
      }}
    />
  );
};

ScoreHistoryTable.propTypes = {
  customerKey: PropTypes.string,
  scoreHistory: PropTypes.array,
  total: PropTypes.number,
  isFetching: PropTypes.bool,
  dispatch: PropTypes.func
};

function mapStateToProps(state, ownProps = {}) {
  const { getRiskScoreHistoryResponse } = state.crsRiskDetailReducer;
  const { isFetching, data } = getRiskScoreHistoryResponse || {};
  const { crsCustomerRiskHistory, count } = data || {};
  return {
    scoreHistory: crsCustomerRiskHistory || [],
    total: count || 0,
    isFetching: isFetching || false
  };
}

function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScoreHistoryTable);
